import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from 'src/app/app.settings.model';
import { ParentChildsService } from 'src/app/shared-component/parent-childs/parent-childs.service';

@Component({
  selector: 'app-parent-child-selector',
  templateUrl: './parent-child-selector.component.html',
  styleUrls: ['./parent-child-selector.component.scss'],
  standalone: false
})
export class ParentChildSelectorComponent implements OnInit {
  @Input() visible: boolean = true;
  @Output() studentSelected = new EventEmitter<{ index: number; student: any }>();

  parentStudents: any[] = [];
  public settings: Settings;

  constructor(
    private parentChildsService: ParentChildsService,
    public appSettings: AppSettings
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit(): void {
    this.loadStudents();
  }

  loadStudents(): void {
    this.parentChildsService.getStudentsByParentId().subscribe(result => {
      this.parentStudents = (result || []).map((student, i) => ({ ...student, isSelected: i === 0 }));
      if (this.parentStudents.length > 0) {
        this.studentSelected.emit({ index: 0, student: this.parentStudents[0] });
      }
    });
  }

  selectStudent(index: number): void {
    this.parentStudents = this.parentStudents.map((student, i) => ({ ...student, isSelected: i === index }));
    this.studentSelected.emit({ index, student: this.parentStudents[index] });
  }
}
